import { useContext } from 'react';
import IdentityContext from '../../contexts/IdentityContext';
import { useTranslation } from 'react-i18next';
import NotificationBanner from '../NotificationBanner';
import useRouting from '../../hooks/useRouting';
import { useLocation } from 'react-router-dom';

export default function LoginNotificationBanner() {
  const { t } = useTranslation();
  const { r } = useRouting();
  const location = useLocation();

  const {
    identity: { isAuthenticated },
  } = useContext(IdentityContext);

  if (isAuthenticated) return null;

  return (
    <NotificationBanner variant="info">
      <span
        dangerouslySetInnerHTML={{
          __html: t('COMPONENTS.NOTIFICATION_BAR.LOGIN', { loginUrl: `${r('login')}?returnUrl=${location.pathname}` }),
        }}
      />
    </NotificationBanner>
  );
}
